import { gql } from 'graphql-tag';

const MAKE_PAYMENT = gql`
  mutation makePayment($makePaymentInput: [MakePaymentInput!]!) {
    makePayment(input: $makePaymentInput) {
      paymentAmount
      remainingBalance
    }
  }
`;

const SUBMIT_FUTURE_CRUISE_CREDITS = gql`
  mutation submitFutureCruiseCredits($codes: [String!]!, $emailAddress: String) {
    submitFutureCruiseCredits(input: { futureCruiseCredits: $codes, emailAddress: $emailAddress }) {
      certificate
      type
    }
  }
`;

const UPDATE_GUESTINFO = gql`
  mutation updateGuestInformation($guestInput: [UpdateGuestInformationInput!]!) {
    updateGuestInformation(input: $guestInput) {
      id
      guests {
        age
        birthDate
        cas
        email
        firstName
        gender
        lastName
        nationality
        stateCode
        travelDocument
        phoneNumber
      }
    }
  }
`;

const VALIDATE_CAS = gql`
  mutation validateCas($cas: String!, $firstName: String, $lastName: String, $birthDate: String) {
    validateCas(
      input: { cas: $cas, firstName: $firstName, lastName: $lastName, birthDate: $birthDate }
    )
  }
`;

const TRIGGER_BOOKING_UPDATE = gql`
  mutation triggerBookingUpdate($initializedFromEmail: Boolean) {
    triggerBookingUpdate(initializedFromEmail: $initializedFromEmail) {
      id
      status
    }
  }
`;

const LOG_DATA = gql`
  mutation LogData($input: BookingDataInput!) {
    logData(input: $input)
  }
`;

export {
  MAKE_PAYMENT,
  SUBMIT_FUTURE_CRUISE_CREDITS,
  UPDATE_GUESTINFO,
  VALIDATE_CAS,
  TRIGGER_BOOKING_UPDATE,
  LOG_DATA,
};
